/* eslint no-underscore-dangle: ["error", { "allow":
 ["__EXCEPTIONTRACE__", "__STATETRACE__", "__STATETRACE_LAST_5__"] }] */
import $ from 'jquery';
import store from '../store/store';
import { tryToLogout } from '../store/session.store';
import { saveInAction, saveFinished } from '../store/allaround.store';

function shouldLock(url, type) {
  return (url && url.indexOf('bugreport') == -1 &&
   (type == 'POST' || type == 'PATCH' || type == 'DELETE' || type == 'PUT'));
}
const commonRequestFunction = (url, data, requestType, userContentType) =>
  new Promise((resolve, reject) => {
    const csrf = store.getState().getIn(['session', 'csrf']);
    let formData;
    if (userContentType === false) {
      formData = data;
    } else {
      formData = JSON.stringify(data);
    }
    if (shouldLock(url, requestType)) {
      saveInAction(store.dispatch);
    }
    $.ajax({
      url: encodeURI(url),
      headers: {
        'X-CSRF-TOKEN': csrf,
      },
      method: requestType,
      data: formData,
      processData: false,
      /* eslint no-unneeded-ternary: ["error", { "defaultAssignment": true }]*/
      contentType: userContentType !== undefined ? userContentType :
        'application/json; charset=utf-8',
    }).done((responseData, textStatus, response) => {
      if (shouldLock(url, requestType)) {
        saveFinished(store.dispatch);
      }
      if (response.getResponseHeader('AuthSuccessful')) {
        resolve({ csrf: response.getResponseHeader('CSRF'),
          firstName: response.getResponseHeader('FirstName'),
          lastName: response.getResponseHeader('LastName'),
          userId: response.getResponseHeader('UserId'),
          roles: response.getResponseHeader('Roles'),
          modules: response.getResponseHeader('Modules'),
          version: response.getResponseHeader('Version'),
          origin: response.getResponseHeader('Origin'),
          applicationRegion: response.getResponseHeader('ApplicationRegion'),
          roleConfigs: JSON.parse(response.getResponseHeader('RoleConfigs')),
          reportConfigs: JSON.parse(response.getResponseHeader('ReportConfigs')),
          customReportOrigins: JSON.parse(response.getResponseHeader('customReportOrigins')),
          supplyDemandResponsibles: JSON.parse(response
            .getResponseHeader('SupplyDemandResponsibles')) });
      } else {
        resolve(responseData);
      }
    }).fail((response) => {
      if (shouldLock(url, requestType)) {
        setTimeout(() => saveFinished(store.dispatch), 0);
      }
      const error = response.responseText && response.responseText != ''
        ? JSON.parse(response.responseText)
        : response;
      const status = response.status;
      if (url.includes('bugreport')) {
        reject(
          { ...error, status }
        );
      } else {
        window.__EXCEPTIONTRACE__.push(
          {
            message: 'API exception',
            lastStates: '',
            error: {
              message: JSON.stringify(response),
            },
          }
        );
        if (status == 401 || (status == 403 && error && typeof error.message == 'string' &&
          error.message.indexOf('Invalid CSRF Token') == 0)) {
          tryToLogout(store.dispatch, false);
        } else if (status != 400 && status != 409) {
          // eslint-disable-next-line
         sendbug();
        }
        reject(
          { ...error, status }
        );
      }
    });
  });

export const RestAPI = {
  get: (url, data, contentType) => commonRequestFunction(url, data, 'GET', contentType),
  post: (url, data, contentType) => commonRequestFunction(url, data, 'POST', contentType),
  patch: (url, data, contentType) => commonRequestFunction(url, data, 'PATCH', contentType),
  put: (url, data, contentType) => commonRequestFunction(url, data, 'PUT', contentType),
  delete: (url, data, contentType) => commonRequestFunction(url, data, 'DELETE', contentType),
};

export const sendbug = (userBugReport) => {
  const sendBugPromise = new Promise((resolve, reject) => {
    if (store.getState().getIn(['session', 'state']) == 'LOGGED_IN') {
      const exceptionTrace = window.__EXCEPTIONTRACE__;
      const environment = {
        version: store.getState().getIn(['session', 'version']) || 'unknown',
        availHeight: window.screen ? window.screen.availHeight : '',
        availWidth: window.screen ? window.screen.availWidth : '',
        height: window.innerHeight,
        width: window.innerWidth,
        language: window.navigator ? window.navigator.language : '',
        languages: window.navigator && window.navigator.languages
          ? window.navigator.languages.join(', ')
          : '',
        appCodeName: window.navigator ? window.navigator.appCodeName : '',
        appName: window.navigator ? window.navigator.appName : '',
        appVersion: window.navigator ? window.navigator.appVersion : '',
        cookieEnabled: window.navigator ? window.navigator.cookieEnabled : '',
        platform: window.navigator ? window.navigator.platform : '',
        userAgent: window.navigator ? window.navigator.userAgent : '',
        vendor: window.navigator ? window.navigator.vendor : '',
      };
      const buginfo = {
        userBugReport: (userBugReport || null),
        environment,
        stateTrace: '',
        exceptionTrace,
      };
      RestAPI
        .post('/bugreport/api/send', buginfo, 'application/json')
        .then(
          (response) => {
            try {
              resolve(response);
            } catch (e) {
              // NOP, if something went wrong
            }
          }
        ).catch(
          (response) => {
            try {
              reject(response, response.status);
            } catch (e) {
              // NOP, if something went wrong
            }
          }
        );
    }
  });

  sendBugPromise.catch(() => {
    // NOP, just to prevent infinite cycle
  });

  return sendBugPromise;
};
